import React, {useContext} from 'react';
import PeVcCard from './PeVcCard';
import TotalFundingUSDCard from './TotalFundingUSDCard';
import TotalFundingInRCard from './TotalFundingInRCard';
import TotalCompaniesCard from './TotalCompaniesCard';
import {TableDataContext} from '../../Contexts/TableDataContext'

/**
 * The `Card` component renders four different cards based on the data provided, displaying various
 * funding and company information.
 * @returns The Card component is returning a JSX element.
 */
 const Card = () => {
  const { data, isLoad, isDataLoad } = useContext(TableDataContext);
  return (
    <div className=""> 
      <div className='sm:full md:mt-[3rem] mt-[4.25rem] h-full bg-[#F2F2F2]'>
           <div className="hidden md:block md:overflow-x-auto lg:grid lg:grid-cols-4 lg:gap-4 lg:px-4 lg:py-[0.7rem] lg:overflow-hidden" style={{scrollbarWidth: 'none'}}>
             <div className="md:grid md:grid-cols-4 md:gap-4 md:px-4 md:py-[0.7rem] md:min-w-max lg:contents">
           {/* ----card1----- */}
          <TotalFundingUSDCard data={data} isLoad={isLoad} isDataLoad={isDataLoad} />
          {/* ----card2----- */}
          <TotalFundingInRCard data={data} isLoad={isLoad} isDataLoad={isDataLoad}/>
          {/* ----card3----- */}
          <TotalCompaniesCard data={data} isLoad={isLoad} isDataLoad={isDataLoad}/> 
          {/* ----card4----- */}
          <PeVcCard data={data} isLoad={isLoad} isDataLoad={isDataLoad}/>

             </div>
            </div>
        <div className='border-b-2 border-[#e5e5e5]'></div>
      </div >
    </div >
  )
}

export default Card;
